import HttpClient from 'server/helpers/HttpClient';
import { getWeakTicket } from 'shared/clientUtils';
import { encrypt } from 'shared/utils';
import { SplunkReporter } from 'reporting/splunk/SplunkReporter';

const splunkReporter = SplunkReporter.getInstance();
const logger = 'businessLogic/Growth/NpeFreeTextEmail';

/**
 * @param err {Error}
 * @returns {'ERROR'}
 **/
const handleGrowthFreeTextError = (err) => {
  splunkReporter.contextual({
    logInfo: { logLevel: 'error', logger },
    event: 'growthFreeText',
    action: 'sendNpeFreeTextEmail',
    activityInfo: {
      status: 'error',
    },
    error: {
      stack: err.stack,
      message: err.message,
    },
  });
  return 'ERROR';
};

export const sendEmailNotification = async ({ state, path = 'npe' }) => {
  try {
    const {
      auth: { ticket, realmId, isUserSignedIn, entityId, syncToken, authToken },
      config: { ssrtid, portal },
      insight: { domainId, token },
    } = state;

    // Use new minimal format - only send token
    const data = {
      token,
    };

    const headers = getWeakTicket({
      domainId,
      entityId,
      realmId,
      token,
      ticket,
      isUserSignedIn,
      syncToken,
      authToken,
      ssrtid,
    });
    const httpClient = HttpClient.getInstance();
    const res = await httpClient({
      url: `/${portal}/rest/growth/oinp/${path}/${realmId}`,
      method: 'POST',
      endpoint: `/rest/growth/oinp/${path}/{realmId}`,
      headers,
      data,
    });
    const { status, data: resData } = res;
    if (status === 200 && resData) {
      return 'SENT_SUCCESSFULLY';
    }
    return 'ERROR';
  } catch (e) {
    return 'ERROR';
  }
};

export const sendNpeFreeTextEmail = async (
  state,
  encryptedFreeTextFormData,
  encryptedOriginalDataLength
) => {
  try {
    const {
      auth: { ticket, realmId, isUserSignedIn, entityId, syncToken, authToken, recipientEmail },
      config: { ssrtid, portal },
      insight: { domainId: _wl, token },
      sale,
    } = state;
    const encryptedData = encrypt(
      '$$R_domainId',
      JSON.stringify({ sale, domainId: _wl, recipientEmail })
    );
    const data = {
      aliasId: { a: encryptedFreeTextFormData, b: encryptedOriginalDataLength, c: encryptedData },
    };

    const headers = getWeakTicket({
      domainId: _wl,
      entityId,
      realmId,
      token,
      ticket,
      isUserSignedIn,
      syncToken,
      authToken,
      ssrtid,
    });
    const httpClient = HttpClient.getInstance();
    const res = await httpClient({
      url: `/${portal}/rest/growth/oinp/npe/freetext/${realmId}`,
      method: 'POST',
      endpoint: `/rest/growth/oinp/npe/freetext/{realmId}`,
      headers,
      data,
    });
    const { status, data: resData } = res;
    if (status === 200 && resData) {
      return 'SENT_SUCCESSFULLY';
    }
    return handleGrowthFreeTextError(new Error('Failed to render and send npe free text email'));
  } catch (e) {
    return handleGrowthFreeTextError(e);
  }
};
